module.exports = __webpack_public_path__ + "static/img/wechatqrcode.5d798055.png";